'use client';

import Script from 'next/script';
import {
  GA_MEASUREMENT_ID,
  GA_REQUIRE_CONSENT,
} from '../../lib/analytics/constants';

/**
 * Loads GA4 gtag.js when `NEXT_PUBLIC_GA_MEASUREMENT_ID` is set.
 * Automatic page views are disabled; {@link AnalyticsRouteListener} sends them.
 */
export function GoogleAnalytics() {
  if (!GA_MEASUREMENT_ID) {
    return null;
  }

  const requireConsent = GA_REQUIRE_CONSENT ? 'true' : 'false';

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy='afterInteractive'
      />
      <Script id='google-analytics-init' strategy='afterInteractive'>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          window.gtag = gtag;
          gtag('js', new Date());
          var requireConsent = ${requireConsent};
          if (requireConsent) {
            gtag('consent', 'default', {
              analytics_storage: 'denied',
              ad_storage: 'denied',
              wait_for_update: 500
            });
          }
          gtag('config', '${GA_MEASUREMENT_ID}', { send_page_view: false });
        `}
      </Script>
    </>
  );
}
